// extracted by mini-css-extract-plugin
export default {"statuteContainer":"ParkStatute_statuteContainer__I4abe","statuteContent":"ParkStatute_statuteContent__J4RMb","description":"ParkStatute_description__z4xqf"};